<template>
    <Loading v-bind:show="showLoadingCashback">
        <div style="display:grid">
            <DadosAluno style=" margin-top: -18px;"></DadosAluno>
            <span class="s-h1" style="margin-bottom:1em; margin-top:13.5px">Cashback</span>
            <span class="s-h2">Resumo</span>
            <template v-if="$featureToggle && $featureToggle.INTEGRA_MENSALIDADES_CASHBACK">
                <div style="margin-left: -15px;">
                    <Info Titulo=""
                          class="horario-info limited-height"
                          v-bind:Informacao="resumo_saldoAcumulado"
                          :key="resumo_saldoAcumulado"
                          Descricao="SALDO ACUMULADO"
                          BordaCor="009688"
                          Tipo="texto" />

                    <Info Titulo=""
                          class="horario-info limited-height"
                          v-bind:Informacao="resumo_possivelAcumular"
                          :key="resumo_possivelAcumular"
                          Descricao="POSSÍVEL ACUMULAR"
                          BordaCor="ffad42"
                          Tipo="texto" />

                    <Info Titulo=""
                          class="horario-info limited-height"
                          v-bind:Informacao="resumo_maximoPossivel"
                          Descricao="MÁXIMO POSSÍVEL"
                          :key="resumo_maximoPossivel"
                          BordaCor="6361fb"
                          Tipo="texto" />
                </div>

                <GridLinha class="cashback-grid"
                           v-if="cashbackFullResponse && cashbackFullResponse.cashbacks"
                           v-bind:Data="cashbackFullResponse.cashbacks"
                           v-bind:Header="headerCashback"
                           Name="Cashback"
                           Title="texto">

                </GridLinha>
                <span v-if="(cashbackFullResponse && !cashbackFullResponse.cashbacks) || cashbackFullResponse.cashbacks.length == 0" style=" text-align: center; margin-top: 29px;" class="s-h2">{{status == "ERR" ? "Erro ao buscar informações" : "Nenhuma informação de Cashback encontrada"}}</span>

            </template>
            <span v-else class="s-h3 regular">Funcionalidade desabilitada no momento</span>
        </div>
    </Loading>

</template>
<script>
    import Mensalidades from '@/services/MensalidadesService.js';
    import Info from '@/components/Info';
    import GridLinha from '@/components/GridLinha';
    import DadosAluno from '@/components/DadosAluno';
    import Loading from '@/components/Loading';
    import { FormataDinheiro, UppercaseIt } from '@/components/CustomFunctions.js';

    export default {

        components: {
            Info,
            GridLinha,
            DadosAluno,
            Loading
        },
        directives: {
        },
        data() {
            return {
                aluno: null,
                status: "INIT",
                resumo_saldoAcumulado: "R$ 0",
                resumo_possivelAcumular: "R$ 0",
                resumo_maximoPossivel: "R$ 0",
                cashbackFullResponse: {
                    cashbacks: null,
                    resumo: {
                        saldoAcumulado: null,
                        possivelAcumular: null,
                        maximoPossivel: null
                    }
                },
                showLoadingCashback: true,
                headerCashback: [
                    { Titulo: "Mensalidade", Field: "boletoMes", Width: "80px", Tipo: "texto", Action: (a) => this.RetornaStringMes(a), },
                    { Titulo: "Situação do Boleto", Field: "situacaoBoleto", Width: "80px", Tipo: "numero" },
                    { Titulo: "Acumulado", Field: "cashbackAcumulado", Width: "80px", Tipo: "numero", Action: (a) => FormataDinheiro(a) },
                    { Titulo: "Possível a acumular", Field: "cashbackPossivel", Width: "80px", Tipo: "moeda", Action: (a) => FormataDinheiro(a) },
                    { Titulo: "Status", Field: "cashbackStatus", Width: "80px", Tipo: "texto" }
                ]
            }
        },
        created() {
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                }
                else
                    this.$router.push('home');
            }

            this.mensalidadesService = new Mensalidades(this);
            this.CarregarCashback(this.aluno.codigoAluno, this.aluno.codigoEspecialidade);
        },
        beforeDestroy() {
        },
        methods: {
            RetornaStringMes(a) {
                let date = new Date(a);
                let month = date.toLocaleString("pt-br", { month: "long" });
                return UppercaseIt(month);
            },


            async CarregarCashback(alucod, espcod) {
                try {
                    if (this.$featureToggle && this.$featureToggle.INTEGRA_MENSALIDADES_CASHBACK) {
                        let cashbackResponse = await this.mensalidadesService.ListarCashback(alucod, espcod);
                        if (cashbackResponse && cashbackResponse.dados) {
                            this.status = "SUCESS";
                            this.cashbackFullResponse = cashbackResponse.dados;
                            this.atualizarResumo(this.cashbackFullResponse.resumo)
                        } else if (!cashbackResponse.ok) {
                            this.status = "ERR";
                            this.$modal.alert("Erro ao buscar cashbacks", cashbackResponse.detalhe ? cashbackResponse.detalhe : "Desconhecido");
                        } 

                    } else {
                        this.$modal.alert(this.$msgFeatureToggle ? this.$msgFeatureToggle : "Dados de habilitação de funcionalidade não encontrados.")
                    }
                    this.showLoadingCashback = false;

                } catch (e) {
                    this.showLoadingCashback = false
                    console.log(e)
                    this.status = "ERR";
                    this.$modal.alert("Não foi possivel carregar informações de cashback.", e.body ? e.body.Detalhe : e);
                }
            },

            atualizarResumo(resumo) {
                if (resumo) {
                    this.resumo_saldoAcumulado = resumo["saldoAcumulado"] == null ? "R$ 0,00" : FormataDinheiro(resumo["saldoAcumulado"]);
                    this.resumo_possivelAcumular = resumo["possivelAcumular"] == null ? "R$ 0,00" : FormataDinheiro(resumo["possivelAcumular"]);
                    this.resumo_maximoPossivel = resumo["maximoPossivel"] == null ? "R$ 0,00" : FormataDinheiro(resumo["maximoPossivel"]);
                }
            }
        }
    }

</script>
<style>
    .cashback-grid .grid-linha,
    .cashback-grid .grid-linha-item,
    .cashback-grid .grid-linha-data {
        text-align: left !important
    }

    .cashback-grid .grid-linha-item {
        height: 50px
    }

    .cashback-grid .grid-linha-data:first-child {
        margin-left: 18px;
        margin-right: -18px
    }

    .cashback-grid .grid-linha-data {
        margin-top: 5px;
        font-size: 12px;
        color: #666666;
    }

    .cashback-grid .grid-header.grid-header.grid-header.grid-header span {
        font-size: 12px !important;
        font-family: "Open Sans" 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
        font-weight: bold !important;
    }

    .cashback-grid .grid-header.grid-header.grid-header.grid-header .md-layout-item:first-child span {
        margin-left: 18px;
    }

    .cashback-grid .grid-header.grid-header.grid-header.grid-header.grid-linha {
        margin-top: 24px;
        margin-bottom: -11px
    }
    .limited-height.divInfo{
        height: 60px !important
    }
</style>
